import { useCallback } from 'react'

import { eventLogger } from 'services/eventLogger.service'

import { ScreenName } from 'root-constants'

export const useScrollEvent = (screenName: ScreenName) => {
  const scrollEvent = useCallback(
    (scrolledPart: number) => {
      eventLogger.logPlanPageViewScroll({
        screenName,
        scrolledPart,
      })
    },
    [screenName],
  )
  return { scrollEvent }
}
